import {Pipe, PipeTransform} from '@angular/core';
import {ModuleDto} from '../../Models/Module/module.interface';

@Pipe({
  name: 'modules',
  standalone: false
})
export class ModulesPipe implements PipeTransform {

  transform(items: ModuleDto[], filter: { favorite: boolean }): ModuleDto[] {

    if (!items.length) {
      return [];
    }

    return items.filter((module) =>
      !module.disableFavorites &&
      module.items.some((item) => filter.favorite ? item.favorite : !item.favorite));

  }

}
